import React from 'react';
import * as styles from './detailedCurriculum.module.scss';
import ProjectCard from './ProjectCard';
import { GUIDED_PROJECT_DETAILS } from './projectDetailsData';

const GuidedProjects = () => {
  return (
    <section id="guided" className={styles.mint}>
      <div className={styles.wrap}>
        <h2 className={styles.secH}>
          Part 2 — <span className={styles.g}>guided production projects.</span>
        </h2>
        <p className={styles.secSub}>
          Each guided project is ~10–12 hours, built with mentor checkpoints, and deployed and
          operated with evaluation, observability and cost control. Every one ships with a
          one-page spec, success metrics, an eval report and a demo narrative — the same
          artefacts an AI engineer produces at work.
        </p>
        {GUIDED_PROJECT_DETAILS.map((p) => (
          <ProjectCard p={p} key={p.id} />
        ))}
      </div>
    </section>
  );
};

export default GuidedProjects;
